export enum CollectionType {
    System = 1,
    User = 2,
    Sharing = 3,
    Feed = 10, // Custom type for user channel
}
